import React from "react";
import { CircularProgress, Box, Typography } from "@mui/joy";

interface LoadingSpinnerProps {
  message?: string;
  size?: "sm" | "md" | "lg";
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = "กำลังโหลด...",
  size = "md",
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 3,
      }}
    >
      <CircularProgress size={size} />
      <Typography level="body-sm" textColor="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
